// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Receipt2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Receipt2/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M20 7.04v9.92c0 1.52-.14 2.6-.5 3.37 0 .01-.01.03-.02.04-.22.28-.51.42-.85.42-.53 0-1.17-.35-1.86-1.09-.82-.88-2.08-.81-2.8.15l-1.01 1.34c-.4.54-.93.81-1.46.81-.53 0-1.06-.27-1.46-.81l-1.02-1.35c-.71-.95-1.96-1.02-2.78-.15l-.01.01c-1.13 1.21-2.13 1.39-2.71.67a.076.076 0 0 1-.02-.04c-.36-.77-.5-1.85-.5-3.37V7.04c0-1.52.14-2.6.5-3.37 0-.01 0-.02.02-.03.57-.73 1.58-.55 2.71.66l.01.01c.82.87 2.07.8 2.78-.15l1.02-1.35c.4-.54.93-.81 1.46-.81.53 0 1.06.27 1.46.81l1.01 1.34c.72.96 1.98 1.03 2.8.15.69-.74 1.33-1.09 1.86-1.09.34 0 .63.15.85.43.02.01.02.02.02.03.36.77.5 1.85.5 3.37ZM8 10.25h8M8 13.75h6"
}));
export default Receipt2Icon;